import { MouseEvent, ReactNode, useCallback, useRef, useState } from 'react';

import ChevronDownSvg from 'global/Securities/components/Icons/ChevronDownSvg';

import { Chevron, Container, Content, ContentWrapper, Title } from './styled';

interface Props {
  title: ReactNode;
  children: ReactNode;
  isPlain?: boolean;
  isTight?: boolean;
}

export default function Accordion({
  children,
  title,
  isPlain = false,
  isTight = false,
}: Props) {
  const [isExpanded, setExpand] = useState<boolean>(false);

  const contentRef = useRef<HTMLDivElement>();
  const contentHeight = isExpanded ? contentRef.current.scrollHeight + 400 : 0;

  const handleExpandToggle = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      setExpand(!isExpanded);
    },
    [isExpanded],
  );

  return (
    <Container>
      <ContentWrapper
        maxHeight={contentHeight}
        isExpanded={isExpanded}
        isPlain={isPlain}
        isTight={isTight}
      >
        <Content ref={contentRef}>{children}</Content>
      </ContentWrapper>
      <Title
        onClick={handleExpandToggle}
        isExpanded={isExpanded}
        isPlain={isPlain}
        isTight={isTight}
      >
        {title}
        <Chevron direction={isExpanded ? 'top' : 'bottom'} isTight={isTight}>
          <ChevronDownSvg />
        </Chevron>
      </Title>
    </Container>
  );
}
